<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Relations",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Relations",
            items: [
               {
                  text: "Relations",
                  active: true,
               },                   
            ],

            relations: [],
            relation: {
               id: null,
               relation : "",
            },
            
            modal_title: "Add Relation",
            button_title: "Save",
            from: null,
            to: null,
            total: null,
            pagination: {},
            edit: false,
            relation_status: {
               id: "",
               status: "",
            },
            keyword: "",
            listing_length: 10,
            status: '',
            token: "",
            errors: {},
            activate: false,
            deactivate: false,
            loading: false,

            active_page_url: null,
         };
      },
      mounted() {
         this.clearLocalStorage();

      },

      created() {
         this.fetchRelations();
      },

      methods: {
         clearLocalStorage() {
            localStorage.removeItem("consultation_filters");
            localStorage.removeItem("cancel_consultation_filters");
            localStorage.removeItem("patient_filters");
            localStorage.removeItem("doctor_filters");

         },

         numbersOnly(event) {
            let keyCode = event.keyCode;
            if (keyCode < 48 || keyCode > 57) {
               event.preventDefault();
            }
         }, 

         fetchRelations(page_url = null) {

            this.getToken();
            let url = "api/admin/relations?keyword=" + this.keyword + "&limit=" + this.listing_length + "&status=" + this.status;

            page_url = page_url || url;

            if(localStorage.back_url) {
               page_url = localStorage.back_url;  
               localStorage.removeItem('back_url');
            }    

            this.active_page_url = page_url;
            this.loading = true;
            
            this.$axios
               .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.relations = responseData.relations.data;
                  
                  this.pagination = responseData.relations.links;
                  this.from = responseData.relations.from;
                  this.to = responseData.relations.to;
                  this.total = responseData.relations.total;
               
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        if(typeof error.response.data.message === 'object') {
                           console.log(error.response.status);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }                        
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         }, 

         getToken() {
            if (localStorage.getItem('medicino_admin')) {
               var medicino_admin =  JSON.parse(localStorage.getItem('medicino_admin'));
               if(medicino_admin.token) {
                  this.token = medicino_admin.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         }, 

         showModal(modal) {
            this.$refs[modal].show();
         },

         hideModal(modal) {
            this.$refs[modal].hide();
         },

         
         clearForm() {           
            
            this.modal_title = "Add Relation";
            this.button_title = "Save";
            this.relation.id = "";
            this.relation.relation = "";           
            this.edit = false;

            this.errors = {};
         },

         addRelation() {
            this.getToken();           
            
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url;
            let formData = new FormData();
            if(!this.edit) {
               url = "api/admin/relation/add";
               this.active_page_url = null;

            } else {
               url = "api/admin/relation/update";
               formData.append("id", this.relation.id); 
            }   
            // url = "api/admin/relation/add";
            // this.active_page_url = null;

            formData.append("relation", this.relation.relation); 

            this.loading = true;
            this.$axios
            .post(url, formData, config)
            .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.hideModal('relation-modal');
                  this.fetchRelations(this.active_page_url);
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         },

         activateRelation(relation) {
            this.activate = false;
              this.$bvModal.msgBoxConfirm('Are you sure you want to publish this relation?', {
                  title: 'Confirm',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
              })
              .then(value => {
                  this.activate = value
                  if(this.activate){
                  this.relation_status.id = relation.id;
                  this.relation_status.status = 1;
                  this.updateRelationStatus();
               }
              })
               .catch(err => {
                  console.log(err);
              })
         },
         deactivateRelation(relation) {
            this.deactivate = false;
              this.$bvModal.msgBoxConfirm('Are you sure you want to unpublish this relation?', {
                  title: 'Confirm',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
              })
               .then(value => {
                  this.deactivate = value
                  if(this.deactivate){
                  this.relation_status.id = relation.id;
                  this.relation_status.status = 2;
                  this.updateRelationStatus();
               }
               })
               .catch(err => {
                  console.log(err);
               })
         },
         updateRelationStatus() {
            
            this.getToken();
            const config = {
               headers: {
                  "Content-type": "application/json",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };    


            let url = "api/admin/relation/status?id=" + this.relation_status.id + "&status=" + this.relation_status.status;
            this.$axios
               .get(url, config)
               .then((response) => {                  
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.fetchRelations(this.active_page_url);
               })
               .catch((error) => {                
                  if (error.response) {
                     if (error.response.data.message) {
                        this.$swal("", error.response.data.message, "error");
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               });
         },
         editRelation(relation) {            
            this.modal_title = "Edit Relation";
            this.button_title = "Update";
            this.relation.id = relation.id;
            this.relation.relation = relation.relationship; 
            this.edit = true;
            this.showModal("relation-modal");
         },
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">
                        <b-button v-b-modal.relation-modal variant="primary" class="float-end">Add Relation</b-button>
                     </div>
                  </div>
                  <!----- top button area ends---->

                  <!----- Listing length and search starts ----->
                  <div class="row mb-3">
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-length" >
                           <label
                              >Show
                              <select class="form-control" v-model="listing_length" @change="fetchRelations()">
                                 <option value="5">5</option>
                                 <option value="10">10</option>
                                 <option value="15">15</option>
                              </select>
                              entries
                           </label>
                        </div>                        
                     </div>
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-filter">
                           <label>
                              <input type="text" class="form-control" placeholder="Search" v-model="keyword" @keyup="fetchRelations()"/>
                           </label>
                        </div>                     
                        <div class="listing-filter me-2">
                           <label>
                              <select class="form-control" v-model="status" @change="fetchRelations()">
                                 <option value="">All</option>
                                 <option value="1">Published</option>
                                 <option value="2">Unpublished</option>
                              </select>
                           </label>
                        </div>   
                     </div>
                  </div>
                  <!----- Listing length and search ends ----->

                  <!---- listing table starts -------->
                  <div class="table-responsive">
                     <table class="table table-bordered mb-0">
                        <thead class="table-light">
                           <tr>
                              <th>SI No.</th>
                              <th>Relation</th> 
                              <th>Created on</th>
                              <th>Options</th>
                           </tr>
                        </thead>
                        <tbody v-if="Boolean(relations.length)">
                           <tr v-for="(relation, index) in relations" :key="relation.id">
                              <td>{{index + from}}</td>
                              <td>{{relation.relationship}}</td>
                              <td>{{relation.created_at | formatDateTime}}</td>
                              <td>   
                                 <b-button variant="primary" class="btn-sm me-2 mt-2" @click="editRelation(relation)">Edit</b-button>
                                 <b-button v-if="relation.status==1" variant="danger" class="btn-sm mt-2 me-2" @click="deactivateRelation(relation)">Unpublish</b-button>
                                 <b-button v-else variant="success" class="btn-sm mt-2 me-2" @click="activateRelation(relation)">Publish</b-button>                                 
                              </td>
                           </tr>
                        </tbody>
                        <tbody v-else>
                           <tr>
                              <td colspan="6" class="text-center">No relations found</td>
                           </tr>
                        </tbody>
                        
                     </table>
                  </div>
                  <!---- listing table ends -------->

                  <!----pagination starts ---> 
                  <caption v-if="Boolean(relations.length)" class="float-start mt-4 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>               
                  <ul class="pagination pagination-rounded mt-4 float-lg-end d-md-inline-flex">
                     <li class="page-item "  v-bind:class="[{disabled: !page.url}, {active: page.active}]" v-for="(page, index) in pagination" :key="page.label">
                        <a href="#" class="page-link" @click.prevent="fetchRelations(page.url + '&limit='+ listing_length + '&keyword=' + keyword + '&status=' + status )">
                           <i v-if="index == 0" class="mdi mdi-chevron-left"></i>
                           <i v-else-if="index == pagination.length-1" class="mdi mdi-chevron-right"></i>
                           <span v-else>{{page.label}}</span>                          
                        </a>
                     </li>
                  </ul>
                  <!----pagination ends --->
                  
                  <!---- modal starts ---->
                  <b-modal ref="relation-modal" id="relation-modal" :title="modal_title" hide-footer @hidden="clearForm()">
                     <b-form @submit.prevent="addRelation()">                        
                        <div class="row"> 
                           <b-col md="12" class="form-group">
                              <label class="control-label">Relation<span class="text-danger">*</span></label>
                              <b-form-input v-model="relation.relation" :class="{ 'is-invalid': Boolean(errors.relation) }" ></b-form-input>

                              <div v-for="(val, index) in errors.relation" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>
                           <b-col md="12" class="mt-3">
                              <b-button type="submit" class="me-3" variant="primary" :disabled="loading">
                                 <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                 {{ loading ? 'Saving...' : button_title }}
                              </b-button>
                              <b-button class="" variant="light" @click="hideModal('relation-modal')" :disabled="loading">Close</b-button>
                           </b-col>
                        </div>                       
                     </b-form>
                  </b-modal>
                  <!---- modal ends ----->

               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
